if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items, 10);
        this.tabletItems = parseInt(this.dataset.tabletItems, 10);
        this.mobileItems = parseInt(this.dataset.mobileItems, 10);
        this.isCartUpsell = this.section?.classList.contains('pp-cart-recommendations');

        this.sliderInstance = false;

        if (!this.enableSlider || !this.sliderWrapper || !this.section) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        // Keep Swiper active on mobile so its navigation buttons stay bound.
        // Swiper also handles touch swipes, so the separate native swipe rail is disabled
        // for slider-enabled sections in the Liquid template.
        this.initSlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

        if (this.isCartUpsell) {
          const desktopItems = Math.max(1, parseInt(this.items, 10) || 6);
          this.sliderOptions = {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: columnGap.mobile || columnGap.tablet || 12,
            navigation: {
              nextEl: this.section.querySelector(this.selectors.nextEl),
              prevEl: this.section.querySelector(this.selectors.prevEl),
            },
            pagination: false,
            breakpoints: {
              768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: columnGap.tablet,
              },
              1024: {
                slidesPerView: desktopItems,
                slidesPerGroup: desktopItems,
                spaceBetween: Math.min(columnGap.tabletLarge || 16, 16),
              },
              1280: {
                slidesPerView: desktopItems,
                slidesPerGroup: desktopItems,
                spaceBetween: Math.min(columnGap.desktop || 16, 16),
              },
            },
            loop: false,
            rewind: false,
            watchOverflow: true,
            threshold: 2,
          };
        } else {
          const mobileItems = Math.max(1, parseInt(this.mobileItems, 10) || 2);
          const tabletItems = Math.max(1, parseInt(this.tabletItems, 10) || 3);
          const desktopItems = Math.max(1, parseInt(this.items, 10) || 4);

          this.sliderOptions = {
            slidesPerView: mobileItems,
            slidesPerGroup: 1,
            spaceBetween: columnGap.mobile || columnGap.tablet || 12,
            navigation: {
              nextEl: this.section.querySelector(this.selectors.nextEl),
              prevEl: this.section.querySelector(this.selectors.prevEl),
            },
            pagination: false,
            breakpoints: {
              768: {
                slidesPerView: tabletItems > 3 ? 3 : tabletItems,
                spaceBetween: columnGap.tablet,
              },
              1024: {
                slidesPerView: Math.min(desktopItems, 4),
                spaceBetween: columnGap.tabletLarge,
              },
              1280: {
                slidesPerView: desktopItems,
                spaceBetween: columnGap.desktop,
              },
            },
            loop: true,
            threshold: 2,
          };
        }

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();

        this.fixQuickviewDuplicate();
        this.calcNavButtonsPosition();

        window.addEventListener(
          'resize',
          FoxTheme.utils.debounce(() => {
            this.calcNavButtonsPosition();
          }, 100)
        );
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calcNavButtonsPosition() {
        if (this.dataset.calcButtonPosition !== 'true') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty(
            '--swiper-navigation-top-offset',
            parseInt(firstMedia.clientHeight, 10) / 2 + 'px'
          );
        }
      }

      calcHeadingColumnHeight() {
        if (this.dataset.calcHeadingColumnHeight !== 'true') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty('--heading-column-height', firstMedia.clientHeight + 'px');
        }
      }

      fixQuickviewDuplicate() {
        const modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
